export type ProjectCargoAsset = "bin-cargo" | "steel-coil" | "wooden-crate";

export const maxProjectSceneStateBytes = 1024 * 1024;

export type ProjectCameraView = {
  id: string;
  name: string;
  state: {
    position: [number, number, number];
    target: [number, number, number];
  };
};

export type ProjectRenderOptions = {
  environmentAndToneMapping: boolean;
  factoryLighting: boolean;
  highDetailBinCargo: boolean;
  pbrMaterials: boolean;
  shadows: boolean;
};

export type ProjectRackState = {
  cargo: Record<string, ProjectCargoAsset | null>;
  cargoCapacities: Record<string, number>;
  layerHeightMode?: "clear";
  layerHeights?: number[];
};

export type ProjectSceneState = {
  cameraViews: ProjectCameraView[];
  devices: Record<string, string>;
  drawingGeneration: number;
  lifts: Record<string, number>;
  racks: Record<string, ProjectRackState>;
  renderOptions: ProjectRenderOptions | null;
  schemaVersion: 1;
  singleStationReciprocatingShuttles: Record<string, number>;
  palletStackerCranes: Record<string, number>;
};

export type ProjectSummary = {
  createdAt: string;
  drawingCompressedBytes?: number;
  drawingFileName?: string;
  drawingGeneration: number;
  drawingHash?: string;
  drawingOriginalBytes?: number;
  id: string;
  name: string;
  updatedAt: string;
  version: number;
};

export type ProjectDetail = ProjectSummary & {
  sceneState: ProjectSceneState;
  sceneStateVersion: number;
};

export function createEmptyProjectSceneState(drawingGeneration = 0): ProjectSceneState {
  return {
    cameraViews: [],
    devices: {},
    drawingGeneration,
    lifts: {},
    racks: {},
    renderOptions: null,
    schemaVersion: 1,
    singleStationReciprocatingShuttles: {},
    palletStackerCranes: {}
  };
}
